import { jsx as _jsx } from "react/jsx-runtime";
import { CodigoBarra } from "./CodigoBarra";
import { Pix } from "./Pix";
export function ScanPayment(_a) {
    var data = _a.data, isOldVersionBillet = _a.isOldVersionBillet;
    return isOldVersionBillet ? _jsx(CodigoBarra, { data: data }) : _jsx(Pix, { data: data });
}
